import { render, staticRenderFns } from "./SelectReactTable.vue?vue&type=template&id=05c2a57d&scoped=true&"
import script from "./SelectReactTable.vue?vue&type=script&lang=js&"
export * from "./SelectReactTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c2a57d",
  null
  
)

export default component.exports